export default "__VITE_ASSET__DMPZ2OQf__"